import { Injectable } from '@angular/core';

import { CloudDataProvider } from '../cloud-data/cloud-data';
import { ConsultationDisplayProvider } from '../consultation-display/consultation-display';

/*
  Generated class for the ConsultationDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConsultationDataProvider
{

   public consultation = {};
   public dispensary = [];


   public editMode = false;
   public editActive = false;


   /** ----- Consultation ----- **/

   public chosenSymptoms = [];
   public chosenSymptomsRemark = [];
   public consRemark = '';
   public dxIdx = -1;
   public dxCustom = '';


   /** ----- Dispensary ----- **/

   public chosenDisps = [];

   public sympActive = true;
   public dispGrpActive = [];
   public dispBoardActive = [];
   public dispBoardDetailsActive = [];
   public usageDetailsActive = false;


   /** ----- Add-on ----- **/

   public noteCons = '';
   public noteDisp = '';
   public noteAcus = '';
   public signCons: any = -1;
   public signDisp: any = -1;
   public signAcus: any = -1;

   public slBegin;
   public slEnd;
   public slRemark = '';


   /** ----- Constructor ----- **/

   constructor( private consultationDisplay: ConsultationDisplayProvider, private cloudData: CloudDataProvider )
   {

      // symptom
      // for ( let i = 0; i < this.symptomChoices.length; i++ )
      // {
      //    this.symptomGrpActive[ i ] = false;
      //    let temp = [];
      //    for ( let j = 0; j < this.symptomChoices[ i ][ 'data' ].length; j++ )
      //    {
      //       temp[ j ] = false;
      //    }
      //    this.symptomItemActive[ i ] = temp;
      // }
      //
      // // dispense grp
      // for ( let i = 0; i < this.dispGrpChoices.length; i++ )
      // {
      //    this.dispGrpActive[ i ] = false;
      // }

   }


   /** ----- Internal Methods ----- **/

   clearAll()
   {

      // reset edit state
      this.editMode = false;
      this.editActive = false;

      // clear symptom data
      this.chosenSymptoms = [];
      this.chosenSymptomsRemark = [];

      // clear dispense data
      this.chosenDisps = [];
      this.sympActive = false;
      this.dispBoardActive = [];
      this.dispBoardDetailsActive = [];
      this.usageDetailsActive = false;
      this.consultation = {};
      this.consRemark = '';
      this.dxIdx = -1;
      this.dxCustom = '';
      this.slBegin = null;
      this.slEnd = null;
      this.slRemark = '';

      this.noteCons = '';
      this.noteDisp = '';
      this.noteAcus = '';

      this.signCons = -1;
      this.signDisp = -1;
      this.signAcus = -1;

      // reset symptom selection state
      for ( let i = 0; i < this.consultationDisplay.symptoms.length; i++ )
      {
         // loop through data
         for ( let j = 0; j < this.consultationDisplay.symptoms[ i ][ 'data' ].length; j++ )
         {
            this.consultationDisplay.symptoms[ i ][ 'data' ][ j ][ 'active' ] = false;
         }
      }

   }


   /** ----- Consultation Methods ----- **/

   addSymptomById = ( inId ) => {

      return new Promise( resolve => {

         // find symptom obj by id and add to list
         let symptomObj = this.consultationDisplay.findSymptom( inId );
         if ( symptomObj != null )
         {
            console.log( 'item found: ' + JSON.stringify( symptomObj ) );
            this.chosenSymptoms.push( symptomObj );
            this.chosenSymptomsRemark.push( '' );
            resolve( true );
         }
         else
         {
            console.log( 'item not found.' );
            resolve( false );
         }
      });
   }


   removeSymptomById = ( inId ) => {

      return new Promise( resolve => {

         // find symptom obj by id and remove from list
         let symptomObj = this.consultationDisplay.findSymptom( inId );
         if ( symptomObj != null )
         {
            if ( this.chosenSymptoms.indexOf( symptomObj ) > -1 )
            {
               this.chosenSymptomsRemark.splice( this.chosenSymptoms.indexOf( symptomObj ), 1 );
               this.chosenSymptoms.splice( this.chosenSymptoms.indexOf( symptomObj ), 1 );
               resolve( true );
            }
            else
            {
               resolve( false );
            }
         }
         else
         {
            resolve( false );
         }
      });
   }


   clearAllSymptomSelection()
   {

      // loop group
      // for ( let i = 0; i < this.symptomItemActive.length; i++ )
      // {
      //    // loop item
      //    for ( let j = 0; j < this.symptomItemActive[ i ].length; j++ )
      //    {
      //       this.symptomItemActive[ i ][ j ] = false;
      //    }
      // }

      // clear all active selection
      this.chosenSymptoms = [];
      this.chosenSymptomsRemark = [];

   }


   addDispense( inGrpIdx, inObj )
   {

      // add dispensary item to list
      this.dispBoardActive.push( false );
      this.dispBoardDetailsActive.push( false );
      let obj = {};
      obj[ 'data' ] = [];
      obj[ 'usage' ] = [];

      // Dispensary-Single OR Dispensary-Grouped
      if ( inGrpIdx == 0 || inGrpIdx == 1 )
      {
         let keys = Object.keys( inObj );
         let params = {};
         for ( let i = 0; i < keys.length; i++ )
         {
            params[ keys[ i ] ] = inObj[ keys[ i ] ];
         }
         obj[ 'data' ].push( params );
      }
      // Internal OR External OR Pills OR Acupuncture-Single OR Acupuncture-Grouped
      else if ( 2 <= inGrpIdx && inGrpIdx <= 6 )
      {
         obj[ 'data' ].push( inObj );
      }
      this.chosenDisps.push( obj );

   }


   addDispenseItem( inTargetIdx, inGrpIdx, inObj )
   {

      if ( inGrpIdx < 0 || inGrpIdx > 6 ) return;

      // prepare for info to be cloned
      let obj = inObj;

      // clone info into params and push into list
      let keys = Object.keys( obj );
      let params = {};
      for ( let i = 0; i < keys.length; i++ )
      {
         params[ keys[ i ] ] = obj[ keys[ i ] ];
      }
      this.chosenDisps[ inTargetIdx ][ 'data' ].push( params );

   }


   clearDispenseSelection( inIdx )   {
      // remove specific selection
      this.chosenDisps.splice( inIdx, 1 );
      this.dispBoardActive.splice( inIdx, 1 );
      this.dispBoardDetailsActive.splice( inIdx, 1 );
   }


   clearDispenseObjSelection( inItemIdx, inItemObjIdx )
   {
      this.chosenDisps[ inItemIdx ][ 'data' ].splice( inItemObjIdx, 1 );
      if(this.chosenDisps[ inItemIdx ]['data'].length == 0){
         this.clearDispenseSelection(inItemIdx);
      }
   }


   clearAllDispenseSelection()   {

      // clear all active selection
      this.chosenDisps = [];
      this.dispBoardActive = [];
      this.dispBoardDetailsActive = [];
   }


   saveAsPending = ( inParams ) => {
      return new Promise( resolve => {
         this.cloudData.saveConsultationAsPending( inParams ).then( res => {
            resolve( res );
         });
      });
   }

   saveAsDone = ( inParams ) => {
      return new Promise( resolve => {
         this.cloudData.saveTicketAsDone( inParams ).then( res => {
            resolve( res );
         });
      });
   }


   archive = ( inParams ) => {
      return new Promise( resolve => {
         resolve();
         // this.cloudData.archiveConsultation( inParams ).then( res => {
         //    resolve( res );
         // });
      });
   }


   getApiDate( inDate )
   {

      let dateStr = '';
      let monthStr = '' + ( inDate.getMonth() + 1 );
      if ( monthStr.length == 1 ) monthStr = '0' + monthStr;
      let dayStr = '' + inDate.getDate();
      if ( dayStr.length == 1 ) dayStr = '0' + dayStr;
      dateStr = inDate.getFullYear() + '-' + monthStr + '-' + dayStr;
      return dateStr;

   }

   
   clearAllChosenSymptoms()
   {
      this.chosenSymptoms = [];
      this.chosenSymptomsRemark = [];
   }

}



// WEBPACK FOOTER //
// ./src/providers/consultation-data/consultation-data.ts